import { render, staticRenderFns } from "./historyGrades.vue?vue&type=template&id=a1cdfd22&scoped=true"
import script from "./historyGrades.vue?vue&type=script&lang=js"
export * from "./historyGrades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1cdfd22",
  null
  
)

export default component.exports